'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.paymentMethodById = paymentMethodById;
exports.automaticPromotions = automaticPromotions;
exports.couponTotal = couponTotal;
exports.orderHasLineItems = orderHasLineItems;
exports.parseSku = parseSku;

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function paymentMethodById(paymentMethods, id) {
  return (0, _lodash.first)((0, _lodash.filter)(paymentMethods, function (paymentMethod) {
    return '' + paymentMethod.id === id;
  }));
}

function eligibleAutomaticPromotion(adjustment) {
  if (!adjustment.eligible) {
    return false;
  }

  return adjustment.sourceType === 'Spree::PromotionAction' && !adjustment.promotionCode;
}

function automaticPromotions(adjustments) {
  return adjustments.reduce(function (promotions, adjustment) {
    return eligibleAutomaticPromotion(adjustment) ? promotions.concat(adjustment) : promotions;
  }, []);
}

function couponTotal(order) {
  return order.adjustments.reduce(function (total, adjustment) {
    return adjustment.promotionCode && adjustment.eligible ? total + parseFloat(adjustment.amount) * -1 : total;
  }, 0);
}

function orderHasLineItems(order) {
  return order.lineItems && order.lineItems.length > 0;
}

function parseSku(sku) {
  var m = sku.match(/^([0-9A-Z_a-z\u017F\u212A]+):([0-9A-Z_a-z\u017F\u212A]+)(?:\-([0-9A-Z_a-z\u017F\u212A]+))?$/i);

  if (!m) {
    throw new Error('not a valid sku');
  }

  var _m$slice = m.slice(1),
      _m$slice2 = (0, _slicedToArray3.default)(_m$slice, 3),
      storeCode = _m$slice2[0],
      articleNumber = _m$slice2[1],
      colorId = _m$slice2[2];

  return {
    storeCode: storeCode,
    articleNumber: articleNumber,
    colorId: colorId
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/helpers/order.js
// module id = 115
// module chunks = 0